<template>
	<div id="page">
		<div class="page-content">
			<div class="page-title page-title-small">
				<h2>
					<!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
					بروزرسانی اپلیکیشن
				</h2>
				<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
				<button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
			</div>
			<div class="card header-card shape-rounded" data-card-height="100">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
			</div>

			<div class="card card-style mb-3">
				<div class="content">
					<div class="text-center">
						<a href="https://dssnovinit.com/" class="text-center mt-4">
							<img src="/assets/images/logo-shadow.png" />
						</a>
					</div>

					<div v-if="info!=null">
						<div class="content mt-1">
							<h3 class="font-700 line-height-xl text-center mt-0">{{info.title}}</h3>
							<div class="row mb-0">
								<div class="col-4 px-0"><p class="color-theme font-500 py-1 text-left">تاریخ بروزرسانی:</p></div>
								<div class="col-8 pl-0"><p class="font-700 py-1">{{ info.updateDateFa}}</p></div>

								<div class="col-4 px-0"><p class="color-theme font-500 py-1 text-left">ورژن فعلی:</p></div>
								<div class="col-8 pl-0"><p class="font-700 py-1">{{appVersionCode}}</p></div>

								<div class="col-4 px-0"><p class="color-theme font-500 py-1 text-left">ورژن جدید:</p></div>
								<div class="col-8 pl-0"><p class="font-700 py-1">{{info.versionCode}}</p></div>

								<div class="col-4 px-0"><p class="color-theme font-500 py-1 text-left">نوع بروزرسانی</p></div>
								<div class="col-8 pl-0">
									<p class="font-700 py-1">
										<span v-if="info.forceUpdate">اجباری</span>
										<span v-if="!info.forceUpdate">پیشنهادی</span>
									</p>
								</div>
								<div class="col-4 px-0"><p class="color-theme font-500 py-1 text-left">توضیحات:</p></div>
								<div class="col-8 pl-0"><p class="font-700 py-1">{{ info.description}}</p></div>
							</div>
						</div>
						<button @click="downloadLastUpdate(info.downloadUrl)" class="btn btn-full bg-highlight btn-m text-uppercase font-900 rounded-s shadow-xl w-100">دانلود بروزرسانی</button>
					</div>
				</div>
			</div>
			<div class="card card-style">
				<p class="boxed-text-l mt-4 mb-2 font-700">
					تهران، خیابان سهروردی شمالی، خیابان میرزای زینالی شرقی، پلاک 61، واحد 7
				</p>
				<a target="_blank" :href="aboutUrl" class="text-center mt-2 font-weight-bold">
					dssnovinit.com
				</a>
				<div class="d-flex justify-content-center align-items-center mb-5 mt-3">
					<a href="https://www.linkedin.com/in/dssnovinit/" class="icon icon-xs rounded-sm shadow-l me-1 bg-facebook mx-1"><i class="fab fa-linkedin-in"></i></a>
					<a href="https://www.instagram.com/taskino.app" class="icon icon-xs rounded-sm shadow-l me-1 bg-pink1-dark mx-1"><i class="fab fa-instagram"></i></a>
					<a href="https://www.aparat.com/dssNovinIt" class="rounded-sm shadow-l me-1 bg-red1-dark mx-1" style="display:inline-flex;justify-content:center;align-items:center;width:38px;height:38px">
						<img src="/assets/images/aparat-icon-white.png" width="20" height="20" />
					</a>
					<a href="tel:02188461250" class="icon icon-xs rounded-sm shadow-l me-1 bg-phone mx-1"><i class="fa fa-phone"></i></a>
				</div>
				<p class="font-16 mt-3 text-center" v-if="isMinVersion==true">
					دسترسی به نسخه وب : https://task.dssnovinit.com
				</p>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				aboutUrl: "",
				info: null
			}
		},
		methods: {
			GetAboutLinkUrl() {
				this.$http.get("Task/GetAboutLinkUrl")
					.then(data => {
						this.aboutUrl = data.data;
					});
			},
			GetMobileAppUpdate() {
				this.$http.get("Account/GetMobileAppUpdate?appVersionCode=" + this.appVersionCode)
					.then(data => {
						if (data.data.versionCode == undefined || data.data.versionCode == null || data.data.versionCode == "") {
							this.showErrorMessage("در حال حاضر نسخه ای جهت بروزرسانی در دسترس نمی باشد!");
							this.info = null;
						} else {
							this.info = data.data;
						}

					});
			},
			downloadLastUpdate(url) {
				window.open(url, "_blank")
			}
		},
		created() {
			this.GetMobileAppUpdate();
			this.GetAboutLinkUrl();
		}
	}
</script>